import * as P from "./palette";
import * as T from "./typography";
import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  palette: P.palette,
  typography: T.typography,
};
